// extracted by mini-css-extract-plugin
module.exports = {"copyIcon":"style_copyIcon__euyNI","copied":"style_copied__SbkhO"};